"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 32,
    xl: 48,
    xxl: 64
};
//# sourceMappingURL=spacing.js.map